import home from "./home.png";
import packageCreate from "./packageCreate.svg";
import excel from "./excel.svg";
import packageList from "./packageList.png";
import cod from "./cod.png";
import support from "./support.png";
import user from "./user.png";
import store from "./store.png";
import box from "./box.svg";
import draft from "./status/draft.svg";
import waiting from "./status/waiting.svg";
import passed from "./status/passed.svg";
import delivering from "./status/delivering.svg";
import success from "./status/success.svg";
import returnIcon from "./status/return.svg";
import lossIcon from "./status/loss.svg";
import failIcon from "./status/fail.svg";
import cancelIcon from "./status/cancel.svg";
import confirmationIcon from "./status/confirmation.svg";

export default {
    homeIcon: home,
    packageCreateIcon: packageCreate,
    excelIcon: excel,
    packageListIcon: packageList,
    codIcon: cod,
    supportIcon: support,
    userIcon: user,
    storeIcon: store,
    boxIcon: box,
    draftIcon: draft,
    waitingIcon: waiting,
    passedIcon: passed,
    deliveringIcon: delivering,
    successIcon: success,
    returnIcon: returnIcon,
    lossIcon: lossIcon,
    failIcon: failIcon,
    cancelIcon: cancelIcon,
    confirmationIcon: confirmationIcon,
};
